import React from 'react';
import { css } from '@linaria/core';

const header = css`
  color: #1a1a1a;
  font-size: 28px;
  line-height: 36px;
  margin: 0 0 40px;
`;

const helpWrapper = css`
  background-color: #fef8e6;
  padding: 40px;

  p {
    color: #1a1a1a;
    font-size: 18px;

    &:first-child {
      margin-top: 0;
    }

    &:not(:last-child) {
      margin-bottom: 20px;
    }
  }

  ul {
    list-style: none;
    padding-left: 0;
    margin: 0 0 30px 20px;

    li {
      position: relative;
      padding-left: 25px;
      margin-bottom: 20px;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 5px;
        height: 5px;
        background-color: #1a1a1a;
      }
    }
  }

  a {
    color: #1a1a1a;
    text-decoration: underline;
    text-decoration-thickness: 1px;
    text-underline-offset: 3px;

    &:hover {
      color: #1a1a1a;
      text-decoration-thickness: 2px;
      text-underline-offset: 2px;
    }
  }
`;

export default function NoResults() {
  const rootElement = document.getElementById('root');
  const noResultsContent =
    rootElement?.getAttribute('data-search-noresults') || '';

  return (
    <>
      <h2 className={header}>No results found</h2>

      <div
        className={helpWrapper}
        dangerouslySetInnerHTML={{ __html: noResultsContent }}
      />
    </>
  );
}
